import React from "react";

import IconButton from "@mui/material/IconButton";
import { MoreVert as MoreVertIcon } from '@vedmarket/ui-kit';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { useCalculationReadOnly } from '../../cabinet/calculator/calculation-read-only';
import LockedIconButton from '../locked-icon-button';

type PropsMenuItem = {
  title: string;
  onClick?(): void,
}

type Props = {
    menuItems: PropsMenuItem[],
    isBig?: boolean;
}

const ShowMoreMenu = ({menuItems, isBig} : Props) => {

  const readOnly = useCalculationReadOnly();

  const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChooseMenuItem = (item: PropsMenuItem) => {
    item.onClick && item.onClick();
    handleClose();
  }

  const iconStyle = isBig ? {
    width: '32px !important',
    height: '32px !important',
  } : undefined;

  if (readOnly) {
    return (
      <LockedIconButton>
        <MoreVertIcon style={iconStyle}/>
      </LockedIconButton>
    );
  }

  return <>
    <IconButton
      id='basic-button'
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup='true'
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClick}
    >
      <MoreVertIcon style={iconStyle}/>
    </IconButton>
    <Menu
      id='basic-menu'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
    >
      {menuItems.map((item, index) => <MenuItem key={index} onClick={() => handleChooseMenuItem(item)}>{item.title}</MenuItem>)}
    </Menu>
  </>
};

export default ShowMoreMenu;
